import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { continueWatching, homeAssets, removeContinue, userContent, bannerPersona, epgProgramLive } from 'src/app/shared/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { UikitService } from './uikit.service';
import { environment } from 'src/environment';
import { WishlistService } from './wishlist.service';
import { SettingsService } from './settings.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  public contentWishlist = new BehaviorSubject<Array<string>>([]);
  public contentWishlistData = new BehaviorSubject<object>({wishListData:[], audioWishListData:[], articleWishListData:[]});
  public audioWishlist = new BehaviorSubject<Array<string>>([]);
  public audioWishlistData = new BehaviorSubject<Array<object>>([]);
  public showHoverCard = new BehaviorSubject<{}>({});
  public hideHoverCard = new BehaviorSubject<boolean>(true);
  public hideHoverCardImmediately = new BehaviorSubject<boolean>(false);
  public userData = new BehaviorSubject<Array<object>>([]);
  public triggerDatamartForHoverCard = new BehaviorSubject<boolean>(false);
  triggerDatamartForHoverCardValue;
  updateUserContent = new BehaviorSubject<boolean>(true);
  updateUserContentFlag = true;
  updateCategoryContentFlag = true;
  public wishlistCount;
  removeListFlage = false;
  absoluteCardHovered = false;

  constructor(private http: HttpClient, private uikitService: UikitService, private wishlistService: WishlistService,
    private settingsService: SettingsService, private route: ActivatedRoute, private storageService: StorageService) { }
  //this service calling for get home content list details
  assets(): Observable<any> {
    const homeAssetsURL = environment.apiEndpoint + environment.v3_version + homeAssets;
    const params: HttpParams = new HttpParams()
      .set('version','v1');
    return this.http.get(homeAssetsURL, { params }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  updateAudioVideoWishlistData(key: 'wishListData' | 'audioWishListData' | 'articleWishListData', value: any[]) {
    const currentData = this.contentWishlistData.value;
    const updatedData = { ...currentData, [key]: value };
    this.contentWishlistData.next(updatedData);
  }


  continueWatching(data): Observable<any> {
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    let params: HttpParams;
    const continueWatchURl = environment.apiEndpoint + environment.version + continueWatching;
    params = new HttpParams()
      .set('skip', data.skip)
      .set('take', data.take)
      .set('profile_id', profileId ?  profileId : uId)
      .set('version','v1');
    if (data?.category) {
      params = params.append('category', data?.category)
    }
    return this.http.get(continueWatchURl, { params }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  userContent(slug?: any): Observable<any> {
    try {
      let partnerSlug = this.route.snapshot.paramMap.get('partnerName');
      let partnerUniqueId;
      if (partnerSlug) {
        let findPartner = this.settingsService.contentPartners.find(obj => obj.slug == partnerSlug);
        partnerUniqueId = findPartner.unique_id;
      }
      const title = slug?.title;
      const skip = slug?.skip;
      const take = slug?.take;
      let params: HttpParams;
      const userContentAPI = environment.apiEndpoint + environment.version + userContent;
      params = new HttpParams()
        .set('version','v1')
      if (title == 'wishlist' && !this.removeListFlage) {
        params = params.append('skip', skip)
          .append('take', take);
      }
      if (!this.route.snapshot.queryParams.partner_id || !partnerSlug) {
        if (slug?.category) {
          params = params.append('category', slug?.category)
        }
      }
      if (this.route.snapshot.queryParams.partner_id || partnerSlug) {
        if (partnerSlug) params = params.append('content_partner_id', partnerUniqueId)
        else params = params.append('content_partner_id', this.route.snapshot.queryParams.partner_id)
      }
      if (slug?.content_type) {
        params = params.append('content_type', slug.content_type)
      }
      if (this.wishlistService.seekCount && this.removeListFlage) {
        const seekVal = this.wishlistService.seekCount + this.settingsService.takeValue;
        params = params.append('skip', '0')
          .append('take', seekVal);
      }
  
      const profileId = this.storageService.getSessionStore('profileId');
      const uId = this.storageService.getLocalStore('u_id');
      params = params.append('profile_id', (profileId || uId));
      params = params.append('facelift', '1');
  
      return this.http.get(userContentAPI, { params }).pipe(
        map((response: any) => {
          if (response.status_code === 200) {
            return response.data;
          }
          else {
            this.uikitService.notifyError(response);
          }
        }), catchError((error) => {
          if (error?.error?.error?.code !== 1002) {
            this.uikitService.notifyError(error);
          }
          return error;
        })
      );
    } catch (error) {
      console.log(error)
    }
  }

  removeContinueWatch(continueId: string): Observable<any> {
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    const removeContinueAPI = environment.apiEndpoint + environment.version + removeContinue;
    const postData = { d_type: 'web', continue_id: continueId, profile_id: profileId || uId };
    return this.http.post(removeContinueAPI, postData).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  bannerpersonainfo(banner, region, locale, partnerId?): Observable<any> {
    banner = banner.map((slide) => {
      return slide.content_id;
    })
    const bannerPersonaURl = environment.apiEndpoint + environment.version + bannerPersona;
    let data;
    if (partnerId) {
      data = { "banner_content_id": banner, "region": region, "locale": locale, "content_partner_id": partnerId,'version':'v1' };
    } else data = { "banner_content_id": banner, "region": region, "locale": locale, 'version':'v1' };

    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    data['profile_id'] = profileId || uId;

    return this.http.post(bannerPersonaURl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error.error && error.error.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

  
  addPersonaData(personaData, datas) {

    const continueData = personaData.find((persona: any) => {return persona.key === 'continue'});
    const wishlistData = personaData.find((persona: any) => {return persona.key === 'wishlist'});
    const topPicksData = personaData.find((persona: any) => {return persona.key === 'top_picks_for_you'});
    const myPurchaseData = personaData.find((persona: any) => {return persona.key === 'purchases'});
    const audioWishlistData = personaData.find((persona: any) => {return persona.key === 'audio_wishlist'});
    const articleWishlistData = personaData.find((persona:any) => {return persona.key === 'article_wishlist'});
    if(articleWishlistData){
      articleWishlistData.collection_type = 'article';
      articleWishlistData.orientation = 1;
    }
    if(audioWishlistData) {
      audioWishlistData.collection_type = 'audio';
      audioWishlistData.orientation = 3;
    }
    datas = datas.map((item) => {
      if (item.component === 'continue_watching_widget') return {...item, ...continueData};
      else if (item.component === 'my_list_widget') {
        if(this.absoluteCardHovered){
          this.hideHoverCardImmediately.next(true)
        }
         return {...item, ...wishlistData};
      } else if (item.component === 'top_picks_for_you_widget') return {...item, ...topPicksData};
      else if (item.component === 'because_you_watched_widget') {
      let watchedData = personaData.find((persona: any) => {
        return persona.key === item.key
      })
      return {...item, ...watchedData }
     }
     else if (item.component === 'my_purchases_widget') {
      if(myPurchaseData?.purchases)this.storageService.setLocalStore('userPurchases', myPurchaseData.purchases);
      return {...item, ...myPurchaseData};
     }
     else if (item.component === 'audio_wishlist'){
      if(this.absoluteCardHovered){
        this.hideHoverCardImmediately.next(true)
      }
       return {...item, ...audioWishlistData};
     }
     else if (item.component === 'article_wishlist'){
      if(this.absoluteCardHovered){
        this.hideHoverCardImmediately.next(true)
      }
       return {...item, ...articleWishlistData};
     }
     else return item;
    });
    return datas
  }

  getwebfallImage(slides) {
    const bannerTemplate = this.settingsService.displayBannerTemplate;
    const imagePath = this.settingsService?.imagePath;

    return slides.map((slide) => {
      let img_first, img_second, port_webp, port_jpg, logo_webp, logo_jpg, homeTile_webp, homeTitle_jpg, onlyLand_Img_webp, onlyLand_Img_jpg;

      const getSlideImage = (image, type) => ({
        webp: this.settingsService.getImage(image, type),
        jpg: imagePath + image
      });

      if (slide?.background_landscape) {
        const { webp, jpg } = getSlideImage(slide.background_landscape, 'banner');
        img_first = webp;
        img_second = jpg;
      } else {
        const { webp, jpg } = getSlideImage(slide.poster_landscape, 'banner');
        img_first = webp;
        img_second = jpg;
      }

      if (slide?.poster_portrait) {
        const { webp, jpg } = getSlideImage(slide.poster_portrait, 'card');
        port_webp = webp;
        port_jpg = jpg;
      }

      if (slide?.content_logo) {
        const { webp, jpg } = getSlideImage(slide.content_logo, 'logo');
        logo_webp = webp;
        logo_jpg = jpg;
        homeTile_webp = webp;
        homeTitle_jpg = jpg;
      }

      if (bannerTemplate === 'only_landscape_banner') {
        if (slide?.poster_landscape) {
          const { webp, jpg } = getSlideImage(slide.poster_landscape, 'banner');
          onlyLand_Img_webp = webp;
          onlyLand_Img_jpg = jpg;
        } else {
          const { webp, jpg } = getSlideImage(slide.background_landscape, 'banner');
          onlyLand_Img_webp = webp;
          onlyLand_Img_jpg = jpg;
        }
      }

      const assignBackground = (first, second) => ({
        bannerbg_webp: first || '',
        bannerbg_fallback: second || ''
      });

      if (bannerTemplate === 'portrait_banner_with_metadata') {
        const bannerData = assignBackground(`url(${img_first})`, ` url(${img_second})`);
        return {
          ...slide,
          ...bannerData,
          bannerimg_first: img_first || '',
          bannerbg_second: img_second || '',
          poster_image_webp: port_webp || '',
          poster_image_jpg: port_jpg || '',
        };
      }

      if (bannerTemplate === 'landscape_banner_with_metadata' || bannerTemplate === 'landscape_banner_mobile_square_with_metadata') {
        const bannerData = assignBackground(`url(${img_first})`, `url(${img_second})`);
        return {
          ...slide,
          ...bannerData,
          bannerimg_first: img_first || '',
          bannerbg_second: img_second || '',
          logo_image_webp: logo_webp || '',
          logo_image_jpg: logo_jpg || '',
          home_page_title_image_webp: homeTile_webp || '',
          home_page_title_image_jpg: homeTitle_jpg || '',
        };
      }

      if (bannerTemplate === 'only_landscape_banner') {
        return {
          ...slide,
          onlyland_banner_image_webp: onlyLand_Img_webp || '',
          onlyland_banner_image_jpg: onlyLand_Img_jpg || ''
        };
      }
    });
  }

  getLivechannelShowcaseData(data): Observable<any> {
    let params: HttpParams;
    params = new HttpParams()
    .set('version','v1');
    if(data.take){
      params = params.append('take', data?.take);
      params = params.append('skip', data?.skip);
    }
    if(data.channel_id) params = params.append('channel_id', data?.channel_id);
    const getEpgProgramUrl =  environment.apiEndpoint + environment.version + epgProgramLive;
    return this.http.get(getEpgProgramUrl, {params}).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }

}
